// extracted by mini-css-extract-plugin
export default {"container":"admin_container__qdVp7","headTitle":"admin_headTitle__U1RRF","addNew":"admin_addNew__+nnyy","icon":"admin_icon__7hGhX"};